import React from 'react';
import { Modal, ModalBody, ModalHeader, Row, Col, Card, CardBody } from 'reactstrap';

const HelpAndSupport = ({ isOpen, toggle }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="md">
            <ModalHeader toggle={toggle} className="border-bottom-0 pb-0">
                <span className="fw-bold fs-4">Help & Support</span>
            </ModalHeader>
            <ModalBody className="pt-0 px-4 pb-4">
                <p className="text-muted mb-4">Get assistance with your care plan and resources</p>

                <div className="mb-4">
                    <h5 className="fw-semibold mb-3">How to use your Care Plan</h5>
                    <ul className="text-muted ps-3">
                        <li className="mb-2">Click on any need card to view details and service organizations</li>
                        <li className="mb-2">Use "Submit Update" to report your progress</li>
                        <li className="mb-2">Follow the step-by-step guide in each need's detail page</li>
                        <li className="mb-2">Upload proof documents as you complete each step</li>
                    </ul>
                </div>

                <hr className="my-4" />

                {/* <div className="mb-2">
                    <h5 className="fw-semibold mb-3">Contact your care coordinator</h5>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Card className="border shadow-none">
                                <CardBody className="d-flex align-items-center p-1 p-md-2">
                                    <div className="rounded-circle bg-soft-success p-2 me-3 d-flex justify-content-center align-items-center">
                                        <i className="fa-solid fa-phone text-success fs-4"></i>
                                    </div>
                                    <div>
                                        <h6 className="mb-1 fw-bold">Call us</h6>
                                        <a href="tel:+14807403456" className="mb-0 text-muted text-decoration-none">
                                            +1 (480) 740-3456
                                        </a>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className="border shadow-none">
                                <CardBody className="d-flex align-items-center p-1 p-md-2">
                                    <div className="rounded-circle bg-soft-success p-2 me-3 d-flex justify-content-center align-items-center">
                                        <i className="fa-regular fa-envelope text-success fs-4"></i>
                                    </div>
                                    <div>
                                        <h6 className="mb-1 fw-bold">Email us</h6>
                                        <a href="mailto:support@groundgame.health" className="mb-0 text-muted text-decoration-none">
                                            support@groundgame.health
                                        </a>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div> */}

                <div className="d-flex justify-content-end mt-4">
                    <button className="btn btn-success px-4" onClick={toggle}>
                        Got it
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default HelpAndSupport;
